import { useEffect, useState } from 'react';
import { accountsService } from '@services/accounts';
import { getActiveAccountId, setActiveAccountId } from '@helpers/auth';

const useAccountSwitcher = enabled => {
    const [accounts, setAccounts] = useState([]);
    const [activeAccountId, setActiveId] = useState(getActiveAccountId());

    useEffect(() => {
        if (!enabled) return;
        accountsService
            .getAccounts()
            .then(data => {
                const list = data || [];
                setAccounts(list);

                const stored = getActiveAccountId();
                if (stored == null || !list.some(a => a.id === stored)) {
                    const resolved = list.find(a => a.isActive) || list[0];
                    if (resolved) {
                        setActiveAccountId(resolved.id);
                        setActiveId(resolved.id);
                    }
                }
            })
            .catch(() => {});
    }, [enabled]);

    const selectAccount = async accountId => {
        await accountsService.setActiveAccount(accountId);
        setActiveAccountId(accountId);
        window.location.assign('/');
    };

    return { accounts, activeAccountId, selectAccount };
};

export default useAccountSwitcher;
